import { getEvents, getEventsUpcoming } from '../../api';
import { transformEventPreview } from '../../transformers';

export const getEventsSuccess = (result) => result?.events?.map((event) => transformEventPreview(event));

export const getUpcomingEvents = (params) => {
  const { venue_id: venueId } = params;
  return getEventsUpcoming({ venue_id: venueId }).then(getEventsSuccess);
};

export const getEventsOnDay = (params) => {
  const { venue_id: venueId, day } = params;
  return getEvents({ venue_id: venueId, day }).then(getEventsSuccess);
};
